import React from 'react';
import './Mixmachinesfeatur.css';


const Mixmachinesfeatur = () => {
    return (
        <div className="Advantagpall-container">
            <div className='Ordinarys'>
                <h2 className="Advantagpall-title">Disha Two Color Injection Molding Machine’s Features</h2>
                <div className="Advantagpall-content">
                    <ul className="Advantagpall-text">
                        <li>The whole machine is a modular design. The clamping part and the
                            injection part can be combined in various ways to expand the scope of selection.</li>
                        <li>Two independent injection systems can be customized according to the amount of injection
                            required by the product. One-time forming of two-color and two-material products
                            can not only shorten the forming cycle but also enhance the flexibility of selection,
                            so as to achieve the highest production efficiency.</li>
                        <li>A set of two-color dies can be used to produce two-color products,
                            Ordinary dies (with the same thickness) can also be used to produce
                            two-color products or single products at the same time,
                            so as to maximize the utilization rate of hoistable and die.</li>
                    </ul>
                    <p className="Material-date">Energy-saving, Excellent performance, Reducing
                        production costs, Easy to operate.</p>
                    <p className="Material-text">disha Plastic Machinery–Turnkey
                        Plastic Molding Solution Manufacturer
                        and Plasticizing the Beautiful World, Always for You!</p>
                </div>
            </div>
        </div>
    );
};
export default Mixmachinesfeatur;
